import { Component } from '@angular/core';
import { SettingsOption } from 'src/app/enums/settings';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent {
    readonly SettingsOption = SettingsOption;
    selectedComponent!: SettingsOption;

    componentMapping: Record<SettingsOption, string> = {
        [SettingsOption.GENERAL]: 'app-general',
        [SettingsOption.DOCUMENT_ACCESS_TYPES]: 'app-document-access-types',
        [SettingsOption.PRIORITIES]: 'app-priorities',
        [SettingsOption.STATUSES]: 'app-status',
        [SettingsOption.DOCUMENT_TYPES]: 'app-document-types',
        [SettingsOption.SERIES_DOCUMENTS]: 'app-series-documents',
        [SettingsOption.SOURCES_DOCUMENTS]: 'app-sources-documents',
        [SettingsOption.PERSONS_ENTITY_TYPES]: 'app-persons-entity-types',
        [SettingsOption.DOCUMENT_FINALIZATION_TYPES]: 'app-document-finalization-types',
        [SettingsOption.TEMPLATE_DOCUMENTE]: 'app-document-template',
        [SettingsOption.CATEGORII_TEMPLATE]: 'app-template-categories',
        [SettingsOption.NON_WORKING_DAYS]: 'app-non-working-days',
        [SettingsOption.DOCUMENT_TYPES_FILES]: 'app-document-types-files',
        [SettingsOption.REDIRECTION_ADDRESSES]: 'app-redirection-addresses',
        [SettingsOption.DIRECTIE_SERII]: 'app-directie-serii',
        [SettingsOption.STATUSURI_POSTA]: 'app-status-posta',
        [SettingsOption.OFICII_POSTALE]: 'app-oficiu-postal',
        [SettingsOption.EMAILS_BLACKLIST]: 'app-emails-blacklist',
        [SettingsOption.OPERATORI]: 'app-operatori',
        [SettingsOption.HEADER_FOOTER]: 'app-document-header-footer',
    };
    componentKeys: string[] = Object.keys(this.componentMapping);

    onChange($event: { value: any }) {
        this.selectedComponent = $event.value;
    }

    selectedSection: any = null;

    constructor(public permissionsService: PermissionsService) {
        this.filterComponents();
    }

    filterComponents() {
        if (!this.permissionsService.hasPermission('indoc-module.settings.general-settings.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.GENERAL
            );
        }

        if (!this.permissionsService.hasPermission('indoc-module.settings.tipuri-access.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.DOCUMENT_ACCESS_TYPES
            );
        }

        if (!this.permissionsService.hasPermission('indoc-module.settings.priorities.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.PRIORITIES
            );
        }

        if (!this.permissionsService.hasPermission('indoc-module.settings.statuses.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.STATUSES
            );
        }

        if (!this.permissionsService.hasPermission('indoc-module.settings.tipuri-documente-registratura.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.DOCUMENT_TYPES
            );
        }

        if (!this.permissionsService.hasPermission('indoc-module.settings.serii-documente.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.SERIES_DOCUMENTS
            );
        }

        if (!this.permissionsService.hasPermission('indoc-module.settings.surse-documente.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.SOURCES_DOCUMENTS
            );
        }

        if (!this.permissionsService.hasPermission('indoc-module.settings.entities.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.PERSONS_ENTITY_TYPES
            );
        }

        if (!this.permissionsService.hasPermission('indoc-module.settings.finalizare-documente.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.DOCUMENT_FINALIZATION_TYPES
            );
        }

        if (!this.permissionsService.hasPermission('indoc-module.settings.template-documente.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.TEMPLATE_DOCUMENTE
            );
        }

        if (!this.permissionsService.hasPermission('indoc-module.settings.categorii-template.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.CATEGORII_TEMPLATE
            );
        }

        if (!this.permissionsService.hasPermission('indoc-module.settings.free-days.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.NON_WORKING_DAYS
            );
        }

        if (!this.permissionsService.hasPermission('indoc-module.settings.tipuri-documente.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.DOCUMENT_TYPES_FILES
            );
        }

        if (!this.permissionsService.hasPermission('indoc-module.settings.inbox-adrese-redirectionare.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.REDIRECTION_ADDRESSES
            );
        }

        if (!this.permissionsService.hasPermission('indoc-module.settings.institutii-servicii-registre-active.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.DIRECTIE_SERII
            );
        }

        if (!this.permissionsService.hasPermission('indoc-module.settings.posta-statuses.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.STATUSURI_POSTA
            );
        }

        if (!this.permissionsService.hasPermission('indoc-module.settings.posta-oficii.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.OFICII_POSTALE
            );
        }

        if (!this.permissionsService.hasPermission('indoc-module.settings.inbox-blacklist.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.EMAILS_BLACKLIST
            );
        }

        if (!this.permissionsService.hasPermission('indoc-module.settings.operatori.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.OPERATORI
            );
        }

        // TODO: Uncomment after adding permission to database
        // if (!this.permissionsService.hasPermission('indoc-module.settings.header-footer.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsOption.HEADER_FOOTER
        //     );
        // }
    }
}
